import type { FC } from 'react';
import type { DefaultMeetingToggleProps } from '../../types';

const DefaultMeetingToggle: FC<DefaultMeetingToggleProps> = ({ checked, disabled, onChange }) => (
  <div className="personal-meetings-modal__form-field">
    <div className="personal-meetings-modal__default-meeting">
      <label className="personal-meetings-modal__toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
        <span className="personal-meetings-modal__toggle-slider" />
      </label>
      <div className="personal-meetings-modal__default-meeting-text">
        <h6>Default Meeting ID</h6>
        <p>Mark this Personal Meeting ID as your default quick-start link.</p>
      </div>
    </div>
  </div>
);

export default DefaultMeetingToggle;
